import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Tabs } from "antd";
import _ from "lodash";
import { Table, Switch } from "antd";

import ModalComponent from "components/modalComponent/ModalComponent";

class ModalKpisManagementContent extends PureComponent {
	updateKpi = switchStatus => {
		const { onChangeSwitchKpisManagement, kpi } = this.props;

		onChangeSwitchKpisManagement(kpi.id, switchStatus);
	};

	render() {
		const { kpi, checked } = this.props;

		return (
			<div className="p-al-full p-mrg-ver">
				<span>{kpi.long_label}</span>
				<Switch
					checked={checked}
					onChange={switchStatus => this.updateKpi(switchStatus)}
				/>
			</div>
		);
	}
}

class ModalKpisRights extends PureComponent {
	render() {
		let {
			user,
			showModal,
			closeModal,
			userKpis,
			kpisList,
			onChangeSwitchKpisManagement,
		} = this.props;
		userKpis = userKpis || [];
		const userKpisList = userKpis.map(userKpi => userKpi.id);
		return (
			<ModalComponent
				title="GESTION DES KPIS"
				showModal={showModal}
				closeModal={closeModal}
				{...this.props}
			>
				<div className="p-mrg-bot-l p-clr-mdg">{user.email}</div>
				{!_.isEmpty(kpisList) &&
					kpisList.map((kpi, i) => (
						<ModalKpisManagementContent
							key={kpi.id}
							kpi={kpi}
							onChangeSwitchKpisManagement={onChangeSwitchKpisManagement}
							checked={userKpisList.includes(kpi.id)}
						/>
					))}
			</ModalComponent>
		);
	}
}

ModalKpisRights.propTypes = {
	showModal: PropTypes.boolean,
	closeModal: PropTypes.function,
	user: PropTypes.object,
	client: PropTypes.object,
};

export default ModalKpisRights;



// WEBPACK FOOTER //
// src/containers/admin/users/ModalKpisRights.js